import { type i18n } from 'i18next';

import { type Languages } from '@/shared/services/localization/types';

import { type Roles } from '../../hooks/use-feature-flag';

export type OpeningMethod =
  | 'sender'
  | 'private'
  | 'group'
  | 'supergroup'
  | 'channel'
  | 'profile_button_or_inline_button_or_chat_menu_button'
  | 'unknown'
  | 'keyboard_button_or_inline_mode';

export enum Orientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export interface ParsedToken {
  authorities: Roles[];
  exp: number;
  gameKey: string;
  iat: number;
  iss: string;
  labels?: string[];
  locale?: string;
  sub?: string;
  type: string;
  username: string;
}

interface AppStateActions {
  hydrate: (fresh: Partial<AppState>) => void;
  setTheme: (cls: ThemeMode) => void;
  setLanguage: (language: Languages) => void;
  setPageWrapperStyle: (cls: PageWrapperStyle) => void;
  reset: () => void;
  updateSingletons: (args: Partial<Singletons>) => void;
}

export enum SingletonName {
  BACK_BUTTON,
}

export type Singletons = Record<SingletonName, boolean>;

export interface AppState {
  token: string;
  parsedToken: ParsedToken | null;
  lang: Languages;
  actions: AppStateActions;
  theme: ThemeMode;
  uiKit: UIKit;
  pageWrapperStyle: PageWrapperStyle;
  marketSessionId: string;
  wsSentInitialMsg: boolean;
  i18n: i18n | undefined;
  singletons: Singletons;
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum UIKit {
  APPLE = 'apple',
  MATERIAL = 'material',
}

export enum PageWrapperStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  COLORED_PRIMARY = 'COLORED_PRIMARY',
  COLORED_SECONDARY = 'COLORED_SECONDARY',
}

export type DefaultAppState = Omit<AppState, 'actions'>;
